import React from "react";
import { Box, Heading, SimpleGrid, Tag, Text, VStack, Wrap, WrapItem } from "@chakra-ui/react";
import Section from "./Section";
import { about, vision, mission } from "../data/content";

const CheckIcon = () => (
  <Box as="svg" viewBox="0 0 24 24" w="18px" h="18px" fill="none" stroke="currentColor" strokeWidth="3" flexShrink={0} mt="3px">
    <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
  </Box>
);

export default function About() {
  return (
    <Section id="about" title="About Us">
      <VStack spacing={5} maxW="3xl" mx="auto" textAlign="center">
        {about.body.map((paragraph, i) => (
          <Text key={i} fontSize={{ base: "md", md: "lg" }} color="ink.600" lineHeight="1.8">
            {paragraph}
          </Text>
        ))}
      </VStack>

      <Box mt={12} textAlign="center">
        <Text fontSize="sm" fontWeight={600} color="ink.500" textTransform="uppercase" letterSpacing="0.1em" mb={4}>
          General Lab Equipment We Supply
        </Text>
        <Wrap justify="center" spacing={3}>
          {about.equipment.map((item) => (
            <WrapItem key={item}>
              <Tag size="lg" bg="brand.50" color="ink.700" border="1px solid" borderColor="brand.200" borderRadius="full" px={4} py={2}>
                {item}
              </Tag>
            </WrapItem>
          ))}
        </Wrap>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mt={14}>
        <Box bg="ink.50" borderRadius="xl" p={{ base: 7, md: 9 }} border="1px solid" borderColor="ink.100">
          <Heading as="h3" fontSize="xl" mb={4}>
            Our Vision
          </Heading>
          <Text color="ink.600" fontSize="lg" lineHeight="1.8">
            {vision}
          </Text>
        </Box>

        <Box bg="ink.50" borderRadius="xl" p={{ base: 7, md: 9 }} border="1px solid" borderColor="ink.100">
          <Heading as="h3" fontSize="xl" mb={4}>
            Our Mission
          </Heading>
          <VStack as="ul" align="stretch" spacing={3} listStyleType="none">
            {mission.map((item) => (
              <Box as="li" key={item} display="flex" gap={3} color="ink.600">
                <Box color="brand.600">
                  <CheckIcon />
                </Box>
                <Text lineHeight="1.7">{item}</Text>
              </Box>
            ))}
          </VStack>
        </Box>
      </SimpleGrid>
    </Section>
  );
}
